import { KeyValueModel } from "../../model";
import { EnumTipoConfig } from "../../model/enums/enum-tipo-config";


export const TpConfigMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoConfig.Texto, "Texto"),
    new KeyValueModel(EnumTipoConfig.Numero, "Numero"),
    new KeyValueModel(EnumTipoConfig.ButtonValidar, "Botão para Validar"),
    new KeyValueModel(EnumTipoConfig.ButtonRedirecionar, "Botão para Redirecionar")
];